export default __webpack_public_path__ + "media/images/carousel/17-2ba49b274a5fd303ffc77787d7ef3049.jpg";